import { type RootState } from "@ds/store/bootstrap";

import { LoadStatus } from "@ds/utils/reducer";

import { selectBaseState } from "./common-selectors";

export const selectAssetUploadData = (state: RootState) => selectBaseState(state).uploadsByFilename;

export const selectAssetIsUploading = (state: RootState) =>
  Object.values(selectAssetUploadData(state)).some(({ loadStatus }) => loadStatus === LoadStatus.Loading);

export const selectAssetIsUploadingFailed = (state: RootState) =>
  Object.values(selectAssetUploadData(state)).some(({ loadStatus }) => loadStatus === LoadStatus.Failed);

export const selectAssetIsUploadingSucceeded = (state: RootState) =>
  Object.values(selectAssetUploadData(state)).every(({ loadStatus }) => loadStatus === LoadStatus.Succeeded);

export const selectIsAssetUploadModalMinimized = (state: RootState) => selectBaseState(state).isUploadModalMinimized;

const selectThumbnailUploadData = (state: RootState) => selectBaseState(state).thumbnailUploadsByFilename;
export const selectThumbnailIsUploading = (state: RootState) =>
  Object.values(selectThumbnailUploadData(state)).some(({ loadStatus }) => loadStatus === LoadStatus.Loading);
